import { FC } from 'react';

import { Link, styled } from '@mui/material';

import { Tooltip } from '@/components';

import { EmptyWidgetProps } from './types';

import styles from './styles.module.scss';

const StyledLink = styled(Link)({
  borderRadius: 3,
  border: '1px solid #232B95',
  color: '#232B95',
  fontSize: 14,
  fontWeight: 600,
  lineHeight: '22px',
  padding: '9px 13px',
  textDecoration: 'none',
});

export const EmptyWidget: FC<EmptyWidgetProps> = ({ title, subtitle, tooltipData, links }) => {
  return (
    <div className={styles.emptyWidget}>
      <div className={styles.emptyWidgetHeader}>
        <h3 className={styles.title}>
          {title} {tooltipData && <Tooltip title={tooltipData} />}
        </h3>

        <p className={styles.subtitle}>{subtitle}</p>
      </div>

      <div className={styles.emptyWidgetBody}>
        {links.map(({ title, path }) => (
          <StyledLink key={title} href={path}>
            {title}
          </StyledLink>
        ))}
      </div>
    </div>
  );
};
